export default __webpack_public_path__ + "static/how-we-teach-ecb719e9133126d00cbb1d90485f971c.png";